import React, { useState, useEffect } from 'react';
import './Home.css';
import ContactForm from './ContactForm';
import Footer from './Footer';

function Home() {
  // Carousel state for hero images
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Array of hero images – using local files from public/images
  // paths start at the public root, so we refer to them with a leading slash
  const heroImages = [
    '/images/Grevol_Safal_India_Showroom.jpeg',
    '/images/Grevol_L5_Loader.jpeg',
    '/images/Grevol-electric-loader.jpeg',
    '/images/Grevol-electric-auto.png',
  ];

  // Auto-rotate images every 2 seconds
  useEffect(() => {
    if (heroImages.length === 0) return;
    
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero" style={heroImages.length > 0 ? { backgroundImage: `url(${heroImages[currentImageIndex]})` } : {}}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">Welcome to SafalIndia Automobiles</h1>
          <p className="hero-subtitle">Safal India Automobiles is an authorized Grevol electric vehicle dealer in Faridabad offering L5 electric autos designed for eco-friendly and cost-effective transportation.</p>
          <p className="hero-subtitle">Safal India Automobiles &mdash; Driving Grevol Towards a Safer, Smarter Tomorrow.</p>
          {/* link to features section */}
          <button
            className="hero-button"
            onClick={() => {
              const el = document.getElementById('services');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Get Started
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section className="features" id="services">
        <div className="features-container">
          <h2 className="section-title">Our Uniqueness</h2>
          <p>Facilities and services that set us apart and drive our success</p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Instant Insurance</h3>
              <p>We offer instant vehicle insurance at our showroom. From policy selection to quick claim support, we ensure your vehicle is protected from day one.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛠️</div>
              <h3>Expert Services</h3>
              <p>We provide complete vehicle care including fitness checkups, engine oiling, and regular servicing. Our expert technicians ensure smooth performance, safety, and long-lasting reliability for your vehicle.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Easy Finance</h3>
              <p>We offer easy vehicle finance with flexible weekly and monthly installment options. Enjoy quick approvals, minimal paperwork, and affordable plans designed to fit your budget.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>RSA</h3>
              <p>We offer reliable RoadSide Assistance across the Delhi NCR region. Whether it's a breakdown or emergency towing, our team ensures quick and dependable support anytime, anywhere.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section (revised) */}
      <section className="about" id="about">
        <div className="about-container">
          <div className="about-content">
            <h2 className="section-title">About Safal India Automobiles</h2>
            <p>
            Safal India Automobiles (Safal India) is an authorized dealership of Grevol, committed to delivering reliable, safe, and affordable mobility solutions. We specialize in smart passenger and commercial L5 electric vehicles, powered by advanced lithium battery packs featuring active thermal management and intelligent cell balancing for enhanced safety, performance, and longevity. With transparent pricing, quick finance approvals, certified servicing, insurance support, and dependable after-sales care, we ensure your vehicle ownership experience is seamless, efficient, and truly worry-free.
            </p>

            <ul className="about-list">
              <li><strong>Authorized Grevol Partner:</strong> Genuine parts, certified service, and official warranty support.</li>
              <li><strong>One-stop Solutions:</strong> Insurance, finance, maintenance, and roadside assistance under one roof.</li>
              <li><strong>Customer-first Process:</strong> Fast documentation, clear pricing, and responsive after-sales care.</li>
            </ul>

            <p>
              Want to learn more? <a className='About-a' href="#contact-form" onClick={(e) => { e.preventDefault(); const el = document.getElementById('contact-form'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}>Contact us </a> and we'll guide you through the next steps.
            </p>
          </div>
        </div>
      </section>

      {/* Specs/Features Section */}
      <section className="specs" id="contact-cta">
        <div className="specs-container">
          <h2 className="section-title">Ready to Start Your Journey?</h2>
          <p className="specs-subtitle">Experience excellence with Grevol vehicles through Safal India Automobiles</p>
          <div className="specs-grid">
            <div className="spec-card">
              <div className="spec-badge-icon">🏎️</div>
              <h3>50 kmph</h3>
              <p>Top Speed</p>
            </div>
            <div className="spec-card">
              <div className="spec-badge-icon">🔋</div>
              <h3>10 kWh</h3>
              <p>Li-ion Battery Pack</p>
            </div>
            <div className="spec-card">
              <div className="spec-badge-icon">⚡</div>
              <h3>4 Hours</h3>
              <p>Charging Time</p>
            </div>
            <div className="spec-card">
              <div className="spec-badge-icon">🛡️</div>
              <h3>3 Years or 1,00,000 km</h3>
              <p>Unconditional Warranty</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <div id="contact-form">
        <ContactForm />
      </div>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default Home;
